<app-programtitle title="Student Database"></app-programtitle>

<p style="color:red;"><i> Warning: You cannot run the programs below as your browswer will stop you accessing your disk as a security measure.</i></p>

<p> Write a program to store student information in a database</p>
<app-editor code="{{program}}"> </app-editor>
